import ajax from "../helpers/ajax";

import {
  VisitorCreateRequest,
  VisitorCreateResult,
  InviteDetails,
  VisitorInvite,
  GroupSelectionRequestModel,
  GroupSelectionResult,
  ExpressionRequestModel,
  VisitorLogRequest
} from "../types";

import StoreContainer from "../stores/StoreContainer";

class VisitorService {
  static async getOrCreate(
    siteId: number,
    data: VisitorCreateRequest
  ): Promise<VisitorCreateResult> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Visitor`,
      method: "post",
      data
    });
  }

  static async getInvite(
    siteId: number,
    inviteId: number,
    groupId: number,
    visitorId: string
  ): Promise<InviteDetails> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Invite/new/${inviteId}`,
      data: { groupId, visitorId }
    });
  }

  static async acceptInvite(
    siteId: number,
    inviteId: number,
    visitorId: string,
    groupId: number
  ): Promise<string> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Invite/Accept`,
      method: "post",
      data: { inviteId, visitorId, groupId }
    });
  }

  static async rejectInvite(
    siteId: number,
    inviteId: number,
    visitorId: string
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Invite/Reject/${inviteId}`,
      method: "get",
      data: { visitorId }
    });
  }

  static async ping(siteId: number, visitorId: string) {
    await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Visitor/ping`,
      method: "post",
      data: { visitorId }
    });
  }

  static async sendGoogleAnalyticsId(
    siteId: number,
    visitorId: string,
    googleAnalyticsId: string
  ) {
    await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Visitor/GoogleAnalyticsId`,
      method: "post",
      data: { visitorId, googleAnalyticsId }
    });
  }

  static async sendHubspotId(
    siteId: number,
    visitorId: string,
    hubspotId: string
  ) {
    await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Visitor/HubspotId`,
      method: "post",
      data: { visitorId, hubspotId }
    });
  }

  static async checkManualInvites(
    siteId: number,
    groupId: number,
    visitorId: string
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Invite/CheckManual/${groupId}/${visitorId}`,
      method: "get"
    });
  }

  static async sendPageHit(
    siteId: number,
    visitorId: string,
    url: string
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/PageHit`,
      method: "post",
      data: { visitorId, url }
    });
  }

  static async sendCampaignVisit(
    siteId: number,
    visitorId: string,
    url: string
  ): Promise<any> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/CampaignVisits`,
      method: "post",
      data: { visitorId, url }
    });
  }

  static async postSession(
    siteId: number,
    visitorId: string,
    groupId: number
  ): Promise<VisitorCreateRequest> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/VisitorSession`,
      method: "post",
      data: { visitorId, groupId }
    });
  }

  static async getInvites(
    siteId: number,
    data: ExpressionRequestModel
  ): Promise<Array<VisitorInvite>> {
    try {
      const response = await ajax({
        url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Invites`,
        method: "post",
        data: data
      });

      return response.Invites;
    } catch (err) {
      console.error(err);
      return [];
    }
  }

  static async groupSelection(
    siteId: number,
    data: GroupSelectionRequestModel
  ): Promise<GroupSelectionResult> {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/GroupSelection`,
      method: "post",
      data: data
    });
  }

  static async postVisitorLog(siteId: number, data: VisitorLogRequest) {
    return await ajax({
      url: `${StoreContainer.SettingStore.getVisitorApiEndpoint()}/v1/${siteId}/Log`,
      method: "post",
      data: data
    });
  }
}

export default VisitorService;
